export const kebabCase = (val) => {
    return val.replace(" ", "-").toLowerCase()
}